<page-heading title="Webhooks" />

<div class="row">
  <div class="col-12">
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-2 input-trend-search">
            <mat-select #searchChannel class="form-control" placeholder="Selecione o canal">
              <mat-option [value]="''">Todos os canais</mat-option>
              <mat-option [value]="'CLOUD_API'">Cloud API</mat-option>
              <mat-option [value]="'Z_API'">TrendBusiness</mat-option>
              <mat-option [value]="'INSTAGRAM_API'">Instagram</mat-option>
              <mat-option [value]="'MESSENGER_API'">Messenger</mat-option>
              <mat-option [value]="'RCS_API'">RCS</mat-option>
              <mat-option [value]="'INTEGRATIONS_API'">Integrações</mat-option>
              <mat-option [value]="'GPT_MAKER_API'">GPT Maker</mat-option>
            </mat-select>
          </div>
          <div class="col-3 input-trend-search">
            <input type="search" #searchPhone class="form-control" placeholder="message.from" />
            <span class="mdi mdi-magnify search-icon ml-2"></span>
          </div>
          <div class="col-4 input-trend-search">
            <input type="search" #searchMessageId class="form-control" placeholder="message.messageId" />
            <span class="mdi mdi-magnify search-icon ml-2"></span>
          </div>

          <div class="col trend-button">
            <!-- <button class="btn btn-info fw-bold" > -->
            <button class="btn btn-primary fw-bold"
              (click)="search(searchChannel.value, searchPhone.value, searchMessageId.value)">
              <i class="ri-search-line"></i> Pesquisar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="card">
  <div class="card-body">
    <div class="row">

      @if (loadingContent) {
      <content-loading-list />
      }

      @if (pager.total === 0) {
      <empty-records-component [message]="'Webhooks'" [subMessage]="'Utilize os filtros para refinar sua busca.'"
        [icon]="'ri-code-line'" />
      }

      @if (pager?.total > 0) {
      <div class="table-responsive">
        <table class="table table-hover table-centered mb-0">
          <thead>
            <tr>
              <th class="text-primary-emphasis">Canal</th>
              <th class="text-primary-emphasis">Data e Hora</th>
              <th class="text-primary-emphasis">Tipo e Conteúdo</th>
              <th class="text-primary-emphasis">Message ID</th>
              <th>&nbsp;</th>
            </tr>
          </thead>
          <tbody>
            @for (item of pager?.list; track item) {
            <tr>
              <td>
                <strong>
                  {{ item.channel }}
                </strong>
                <br />
                {{ item.createdAt | timezoneDate: 'DD/MM/YYYY HH:mm:ss:SSS': getTimezoneCompanyCurrentUser()}}
              </td>
              <td>
                {{ item.message?.["from"] }}<br />
                {{
                item.message?.["contactProfileName"]?.slice(0, 19) + "..."
                }}
              </td>
              <td>
                {{ item.message?.["type"] || item.message?.["statuses"]?.['status'] }}<br />
                {{ $safeNavigationMigration(item.event?.["data"]?.["message"]?.["conversation"]) !== null
                ?
                item.event?.["data"]?.["message"]?.["conversation"]?.slice(0, 19) + "..."
                :
                'null'
                }}
              </td>
              <td>
                @if (item.message?.["messageId"]) {
                <button type="button" class="btn btn-outline-primary btn-sm rounded-pill"
                  (click)="viewMessage($safeNavigationMigration(item.message?.['messageId']))">
                  {{ item.message?.["messageId"].slice(0, 19) }}
                </button>
                } @else {
                ---
                }
              </td>
              <td align="right">
                <button class="btn btn-secondary btn-sm" (click)="view(item)">
                  <i class="mdi mdi-magnify font-18"></i>
                  Visualizar
                </button>
              </td>
            </tr>
            }
          </tbody>
        </table>
      </div>

      @if (pager.total > pager.perPage) {
      <paginator [pager]="pager" (onPager)="loadPage($event)" />
      }
      }

    </div>
  </div>
</div>